// Trending Global (2026-10-18) — panel super admin: status YouTube Data API key & kuota, riwayat
// putaran kolektor (trend-collector.js), niche + kata kunci per bahasa, dan perkiraan RPM per negara.
// Backend: routes/trending-admin.js di eighteen-media-api.
import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://api.eighteen-media.id';
const card = { background: 'rgba(255,255,255,0.055)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 12, padding: 18, marginBottom: 14 };
const inp = { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.14)', color: '#f1f5f9', borderRadius: 8, padding: '8px 10px', fontSize: 13, boxSizing: 'border-box' };
const btn = { background: 'rgba(160,107,255,0.18)', border: '1px solid #a06bff', color: '#e9ddff', borderRadius: 8, padding: '7px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' };
const btnGhost = { ...btn, background: 'transparent', border: '1px solid rgba(255,255,255,0.18)', color: '#cbd5e1' };
const h = { fontSize: 15, fontWeight: 700, color: '#f1f5f9', margin: '0 0 10px' };
const muted = { fontSize: 12, color: '#94a3b8' };
const STATUS = { done: ['Selesai', '#22c55e'], partial: ['Sebagian (kuota)', '#f59e0b'], failed: ['Gagal', '#ef4444'], running: ['Berjalan', '#22d3ee'] };
const waktu = d => d ? new Date(d).toLocaleString('id-ID', { dateStyle: 'short', timeStyle: 'short' }) : '-';

// {"en":["a","b"]} <-> "en: a, b" per baris
const kwToText = kw => Object.entries(kw || {}).map(([l, a]) => `${l}: ${(a || []).join(', ')}`).join('\n');
const textToKw = t => {
  const out = {};
  String(t || '').split('\n').forEach(line => {
    const m = line.match(/^\s*([a-zA-Z-]{2,8})\s*:\s*(.+)$/);
    if (m) out[m[1].toLowerCase()] = m[2].split(',').map(s => s.trim()).filter(Boolean);
  });
  return out;
};

function NicheRow({ n, onSaved }) {
  const [edit, setEdit] = useState(false);
  const [label, setLabel] = useState(n.label);
  const [grup, setGrup] = useState(n.grup || 'Musik');
  const [kw, setKw] = useState(kwToText(n.keywords));
  const [err, setErr] = useState('');
  const simpan = async (body) => {
    setErr('');
    try { await axios.put(`${API}/api/admin/trending/niches/${n.key}`, body); setEdit(false); onSaved(); }
    catch (e) { setErr(e.response?.data?.error || e.message); }
  };
  const nKw = Object.values(n.keywords || {}).reduce((a, x) => a + (x || []).length, 0);
  return (
    <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', padding: '10px 0' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
          <input type="checkbox" checked={n.active} onChange={e => simpan({ active: e.target.checked })} style={{ width: 16, height: 16, margin: 0 }} />
        </label>
        <b style={{ color: n.active ? '#f1f5f9' : '#64748b', fontSize: 13, minWidth: 150 }}>{n.label}</b>
        <span style={muted}>{n.grup} · {n.key} · {nKw} kata kunci · {Object.keys(n.keywords || {}).join(', ')} · {n.videos_72h} video (72 jam) · dicari {n.last_searched_at ? waktu(n.last_searched_at) : 'belum pernah'} ({n.search_count}×) · ringkasan {n.summary_at ? waktu(n.summary_at) : 'belum'}</span>
        <span style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
          {n.summary_at && <button style={btnGhost} onClick={() => simpan({ resetSummary: true })} title="Dirangkum ulang pada putaran berikutnya">Rangkum ulang</button>}
          <button style={btnGhost} onClick={() => setEdit(!edit)}>{edit ? 'Tutup' : 'Edit'}</button>
        </span>
      </div>
      {edit && (
        <div style={{ marginTop: 10, display: 'grid', gap: 8 }}>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <input style={{ ...inp, flex: '2 1 200px' }} value={label} onChange={e => setLabel(e.target.value)} placeholder="Nama niche" />
            <input style={{ ...inp, flex: '1 1 120px' }} value={grup} onChange={e => setGrup(e.target.value)} placeholder="Grup (Musik / Non-musik)" list="trend-grup" />
          </div>
          <textarea style={{ ...inp, minHeight: 110, fontFamily: 'monospace' }} value={kw} onChange={e => setKw(e.target.value)} />
          <div style={muted}>Satu baris per bahasa: <code>kode: kata kunci 1, kata kunci 2</code>. Kode bahasa 2 huruf (en, es, pt, ja, ko, de, fr, id…). Kolektor memakai satu kata kunci per putaran secara bergiliran; tiap pencarian = 100 unit kuota.</div>
          {err && <div style={{ color: '#ef4444', fontSize: 12 }}>{err}</div>}
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={btn} onClick={() => simpan({ label, grup, keywords: textToKw(kw) })}>Simpan</button>
            <button style={{ ...btnGhost, color: '#ef4444', borderColor: '#ef4444' }} onClick={async () => {
              if (!window.confirm(`Hapus niche ${n.label}?`)) return;
              await axios.delete(`${API}/api/admin/trending/niches/${n.key}`); onSaved();
            }}>Hapus</button>
          </div>
        </div>
      )}
    </div>
  );
}

function TambahNiche({ onSaved }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ key: '', label: '', grup: 'Non-musik', kw: 'en: ' });
  const [err, setErr] = useState('');
  if (!open) return <button style={btnGhost} onClick={() => setOpen(true)}>+ Tambah niche</button>;
  return (
    <div style={{ display: 'grid', gap: 8, marginTop: 10 }}>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <input style={{ ...inp, flex: '1 1 140px' }} placeholder="kode (mis. jazz)" value={f.key} onChange={e => setF({ ...f, key: e.target.value })} />
        <input style={{ ...inp, flex: '2 1 200px' }} placeholder="Nama (mis. Jazz Cafe)" value={f.label} onChange={e => setF({ ...f, label: e.target.value })} />
        <input style={{ ...inp, flex: '1 1 120px' }} placeholder="Grup" value={f.grup} onChange={e => setF({ ...f, grup: e.target.value })} list="trend-grup" />
      </div>
      <textarea style={{ ...inp, minHeight: 80, fontFamily: 'monospace' }} value={f.kw} onChange={e => setF({ ...f, kw: e.target.value })} />
      {err && <div style={{ color: '#ef4444', fontSize: 12 }}>{err}</div>}
      <div style={{ display: 'flex', gap: 8 }}>
        <button style={btn} onClick={async () => {
          setErr('');
          try { await axios.post(`${API}/api/admin/trending/niches`, { key: f.key, label: f.label, grup: f.grup, keywords: textToKw(f.kw) }); setOpen(false); setF({ key: '', label: '', grup: 'Non-musik', kw: 'en: ' }); onSaved(); }
          catch (e) { setErr(e.response?.data?.error || e.message); }
        }}>Simpan</button>
        <button style={btnGhost} onClick={() => setOpen(false)}>Batal</button>
      </div>
    </div>
  );
}

function RegionRow({ r, onSaved }) {
  const [rpm, setRpm] = useState(String(r.rpm));
  const simpan = async (body) => { try { await axios.put(`${API}/api/admin/trending/regions/${r.code}`, body); onSaved(); } catch (e) { alert(e.response?.data?.error || e.message); } };
  const chart = r.chart_ok === false ? '✕ tanpa chart' : r.chart_ok ? '✓' : '·';
  const musik = r.music_ok === false ? '✕' : r.music_ok ? '✓' : '·';
  return (
    <tr style={{ borderTop: '1px solid rgba(255,255,255,0.06)', opacity: r.active ? 1 : 0.5 }}>
      <td style={{ padding: '5px 6px' }}><input type="checkbox" checked={r.active} onChange={e => simpan({ active: e.target.checked })} style={{ width: 15, height: 15, margin: 0 }} /></td>
      <td style={{ padding: '5px 6px', fontFamily: 'monospace' }}>{r.code}</td>
      <td style={{ padding: '5px 6px' }}>{r.name}</td>
      <td style={{ padding: '5px 6px' }}>
        <input style={{ ...inp, width: 70, padding: '4px 6px' }} value={rpm} onChange={e => setRpm(e.target.value)}
          onBlur={() => { if (Number(rpm) !== r.rpm) simpan({ rpm: Number(rpm) }); }} />
      </td>
      <td style={{ padding: '5px 6px', color: '#94a3b8' }}>{chart}</td>
      <td style={{ padding: '5px 6px', color: '#94a3b8' }}>{musik}</td>
      <td style={{ padding: '5px 6px' }}>{r.chart_ok === false && <button style={{ ...btnGhost, padding: '3px 8px' }} onClick={() => simpan({ retry: true })}>Coba lagi</button>}</td>
    </tr>
  );
}

export default function TrendingAdmin() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');
  const [cari, setCari] = useState('');
  const load = useCallback(() => axios.get(`${API}/api/admin/trending`).then(r => { setD(r.data); setErr(''); }).catch(e => setErr(e.response?.data?.error || e.message)), []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (!d || !d.runs.some(r => r.status === 'running')) return undefined;
    const t = setInterval(load, 8000); return () => clearInterval(t);
  }, [d, load]);

  const jalankan = async (only) => {
    setMsg('');
    try { await axios.post(`${API}/api/admin/trending/run`, only ? { only } : {}); setMsg('Kolektor dijalankan di latar belakang. Halaman ini memuat ulang sendiri.'); setTimeout(load, 3000); }
    catch (e) { setMsg('❌ ' + (e.response?.data?.error || e.message)); }
  };

  if (err) return <div style={card}><div style={{ color: '#ef4444' }}>{err}</div></div>;
  if (!d) return <div style={card}>Memuat…</div>;
  const pct = Math.min(100, Math.round((d.unitsToday / d.budget) * 100));
  const regions = d.regions.filter(r => !cari || `${r.code} ${r.name}`.toLowerCase().includes(cari.toLowerCase()));

  return (
    <div>
      <h2 style={{ fontSize: 22, fontWeight: 700, color: '#f1f5f9', margin: '0 0 6px' }}>📈 Trending Global</h2>
      <div style={{ ...muted, marginBottom: 16 }}>Video trending YouTube semua negara (semua kategori; chart Game/Hiburan/dll. diambil untuk 25 negara ber-RPM tertinggi) + niche global. Niche tidak harus musik — tambah apa saja (ASMR, Minecraft, masak, …). Dikumpulkan tiap 6 jam memakai YouTube Data API key; klien hanya membaca hasilnya (tidak memakan kuota). Fitur dibuka per klien lewat centang "Trending Global".</div>

      <div style={card}>
        <div style={h}>Key & kuota</div>
        {d.key.ada
          ? <div style={{ fontSize: 13, color: '#22c55e', marginBottom: 8 }}>✓ YT_DATA_API_KEY terpasang (…{d.key.akhir})</div>
          : <div style={{ fontSize: 13, color: '#f59e0b', marginBottom: 8 }}>⚠ YT_DATA_API_KEY belum diisi di .env server — kolektor belum bisa jalan dan menu klien masih tersembunyi.</div>}
        <div style={{ fontSize: 13, color: '#e2e8f0' }}>Hari kuota {d.today} (zona Pasifik): <b>{d.unitsToday.toLocaleString('id-ID')}</b> / {d.budget.toLocaleString('id-ID')} unit anggaran (batas Google 10.000)</div>
        <div style={{ height: 8, background: 'rgba(255,255,255,0.08)', borderRadius: 4, margin: '8px 0 12px', overflow: 'hidden' }}>
          <div style={{ width: `${pct}%`, height: '100%', background: pct > 85 ? '#ef4444' : pct > 60 ? '#f59e0b' : '#a06bff' }} />
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          <button style={{ ...btn, ...(d.key.ada ? {} : { opacity: 0.4, cursor: 'not-allowed' }) }} disabled={!d.key.ada} onClick={() => jalankan()}>▶ Jalankan sekarang (±1.850 unit)</button>
          <button style={{ ...btnGhost, ...(d.key.ada ? {} : { opacity: 0.4, cursor: 'not-allowed' }) }} disabled={!d.key.ada} onClick={() => jalankan('chart')}>Chart negara saja (±520 unit)</button>
          <button style={btnGhost} onClick={load}>Muat ulang</button>
          {msg && <span style={{ fontSize: 12, color: msg.startsWith('❌') ? '#ef4444' : '#22c55e' }}>{msg}</span>}
        </div>
      </div>

      <div style={card}>
        <div style={h}>Riwayat putaran</div>
        {d.runs.length === 0 ? <div style={muted}>Belum pernah jalan.</div> : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, color: '#e2e8f0' }}>
              <thead><tr style={{ color: '#94a3b8', textAlign: 'left' }}><th style={{ padding: 6 }}>#</th><th style={{ padding: 6 }}>Mulai</th><th style={{ padding: 6 }}>Status</th><th style={{ padding: 6 }}>Video</th><th style={{ padding: 6 }}>Unit</th><th style={{ padding: 6 }}>Catatan</th></tr></thead>
              <tbody>{d.runs.map(r => {
                const [t, c] = STATUS[r.status] || [r.status, '#94a3b8'];
                return (
                  <tr key={r.id} style={{ borderTop: '1px solid rgba(255,255,255,0.06)', verticalAlign: 'top' }}>
                    <td style={{ padding: 6 }}>{r.id}</td><td style={{ padding: 6, whiteSpace: 'nowrap' }}>{waktu(r.started_at)}</td>
                    <td style={{ padding: 6, color: c, whiteSpace: 'nowrap' }}>{t}</td><td style={{ padding: 6 }}>{r.videos}</td><td style={{ padding: 6 }}>{r.units}</td>
                    <td style={{ padding: 6, color: '#94a3b8', whiteSpace: 'pre-wrap', maxWidth: 420 }}>{r.note || ''}</td>
                  </tr>
                );
              })}</tbody>
            </table>
          </div>
        )}
      </div>

      <div style={card}>
        <div style={h}>Niche & kata kunci</div>
        {(() => { const aktif = d.niches.filter(n => n.active).length, per = Math.min(d.nichePerRun, aktif) || 1; return (
          <div style={{ ...muted, marginBottom: 6 }}>{aktif} niche aktif. Tiap putaran (4×/hari) mencari {per} niche yang paling lama belum dicari ({(per * 100).toLocaleString('id-ID')} unit) → tiap niche diperbarui ±{Math.max(6, Math.round(6 * aktif / per))} jam sekali. Menambah niche tidak menambah biaya, hanya memperjarang pembaruan. Centang = ikut dikumpulkan.</div>
        ); })()}
        <datalist id="trend-grup">{[...new Set(d.niches.map(n => n.grup))].map(g => <option key={g} value={g} />)}</datalist>
        {d.niches.map(n => <NicheRow key={n.key} n={n} onSaved={load} />)}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 10 }}><TambahNiche onSaved={load} /></div>
      </div>

      <div style={card}>
        <div style={h}>Negara & perkiraan RPM</div>
        <div style={{ ...muted, marginBottom: 8 }}>RPM = perkiraan USD per 1.000 views, hanya untuk label "Pasar tinggi/sedang/rendah" (≥3 tinggi, ≥1 sedang). Daftar lengkap negara terisi otomatis dari YouTube pada putaran pertama. Chart/Musik: ✓ tersedia, ✕ YouTube tidak menyediakan, · belum dicoba.</div>
        <input style={{ ...inp, width: '100%', maxWidth: 280, marginBottom: 8 }} placeholder="Cari negara…" value={cari} onChange={e => setCari(e.target.value)} />
        <div style={{ overflowX: 'auto', maxHeight: 460, overflowY: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, color: '#e2e8f0' }}>
            <thead><tr style={{ color: '#94a3b8', textAlign: 'left' }}><th style={{ padding: 6 }}>Aktif</th><th style={{ padding: 6 }}>Kode</th><th style={{ padding: 6 }}>Negara</th><th style={{ padding: 6 }}>RPM $</th><th style={{ padding: 6 }}>Chart</th><th style={{ padding: 6 }}>Musik</th><th></th></tr></thead>
            <tbody>{regions.map(r => <RegionRow key={r.code} r={r} onSaved={load} />)}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
